import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { User } from "src/app/domain/user";
import { Injectable } from "@angular/core";
import { UserEntity } from "../user.entity";
import { InterventionEntity } from "../intervention.entity";

@Injectable({
    providedIn: 'root',
})
export class UserRepository {
    
    async getUserById(id: number) {
        return await db.users.where('Id').equals(id).first(async ue => {
            const user = mapper.map(ue, UserEntity, User);
            return user;
        });
    }

    async attachUser(user: User, interventionEntity: InterventionEntity, forSampler: boolean) {
        let userId: number;
        const ue = mapper.map(user, User, UserEntity);

        userId = await db.users.add(ue);
        if (forSampler) {
            await db.interventions.update(interventionEntity.Id!, {
                SamplerId: userId
            });
        } else {
            await db.interventions.update(interventionEntity.Id!, {
                ContactId: userId
            });
        }
        return userId;
    }
}